module.exports = __webpack_public_path__ + "img/company_map.522fadf5.png";